import { Requirement } from "@revmatics/catalyst";

export const passwordRequirements: Requirement[] = [
  { id: "length", regex: /.{8,}/, text: "At least 8 characters" },
  { id: "letter", regex: /[a-zA-Z]/, text: "At least one letter" },
  { id: "number", regex: /[0-9]/, text: "At least one number" },
  {
    id: "special",
    regex: /[^A-Za-z0-9]/,
    text: "At least one special character",
  },
];
